// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__1RJn_","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__1oEar"};